export interface TransitionTypeMigrationResult {
  transitionType: string;
  migratedFromLegacySmooth: boolean;
}

/**
 * Backward compatibility: historical saves wrote "smooth" by default.
 * Treat that legacy value as "none" when loading.
 */
export const migrateLegacyTransitionType = (
  transitionType: string | null | undefined
): TransitionTypeMigrationResult => {
  const raw = typeof transitionType === 'string' ? transitionType.trim() : '';
  if (raw.toLowerCase() === 'smooth') {
    return { transitionType: 'none', migratedFromLegacySmooth: true };
  }

  return {
    transitionType: raw || 'none',
    migratedFromLegacySmooth: false
  };
};
